var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7246 17.2913L15.8305 13.3971C15.6547 13.2214 15.4165 13.1237 15.1665 13.1237H14.5298C15.6079 11.7449 16.2484 10.0107 16.2484 8.12421C16.2484 3.63636 12.612 0 8.12421 0C3.63636 0 0 3.63636 0 8.12421C0 12.612 3.63636 16.2484 8.12421 16.2484C10.0107 16.2484 11.7449 15.6079 13.1237 14.5298V15.1665C13.1237 15.4165 13.2214 15.6547 13.3971 15.8305L17.2913 19.7246C17.6584 20.0918 18.2521 20.0918 18.6154 19.7246L19.7207 18.6193C20.0879 18.2521 20.0879 17.6584 19.7246 17.2913ZM8.12421 13.1237C5.36276 13.1237 3.12469 10.8896 3.12469 8.12421C3.12469 5.36276 5.35885 3.12469 8.12421 3.12469C10.8857 3.12469 13.1237 5.35885 13.1237 8.12421C13.1237 10.8857 10.8896 13.1237 8.12421 13.1237Z",
    fill: "#F4F6F9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchWhite);
export default __webpack_public_path__ + "static/media/SearchWhite.79df9e9f129dd2c54f665b515aca7dff.svg";
export { ForwardRef as ReactComponent };